<template>
  <div class="member-test">
    <el-tabs
      class="el-tabs-common"
      v-model="labelCurrent"
      @tab-click="changeLabelTab"
    >
      <el-tab-pane
        v-for="(item, index) in labelTypes"
        :key="index"
        :name="item.type"
        :label="item.label"
      ></el-tab-pane>
    </el-tabs>
    <!-- <el-tabs class="el-tabs-common" v-model="current" @tab-click="changeTab">
      <el-tab-pane
        v-for="(item, index) in types"
        :key="index"
        :name="item.type"
        :label="item.label"
      ></el-tab-pane>
    </el-tabs> -->
    <div class="tab-box">
      <p
        class="item"
        @click="changeTab(item.type)"
        v-for="(item, index) in types"
        :key="index"
        :class="{ active: current == item.type }"
      >
        {{ item.label }}
      </p>
    </div>
    <div
      v-if="labelCurrent == 0 && (current == 0 || current == 1)"
      class="filter"
    >
      <el-checkbox @change="changeCheck" :value="testChecked"></el-checkbox>
      <span class="filter-text">隐藏尚未达到考试条件的考试</span>
    </div>
    <div class="member-test-content">
      <template v-if="testList && testList.length > 0">
        <template v-if="labelCurrent == 0">
          <TestCard
            class="member-test-card"
            v-for="item in testList"
            :key="item.id"
            :test-info="item"
          />
        </template>
        <template v-else>
          <NoticeTestCard
            class="member-test-card"
            v-for="item in testList"
            :key="item.id"
            :test-info="item"
            @applySuccess="getNoticeTestList()"
          />
        </template>

        <el-pagination
          class="pager"
          background
          @current-change="onCurrentChange"
          :current-page="page"
          :page-size="limit"
          layout="prev, pager, next"
          :total="total"
          v-if="total > 10"
        ></el-pagination>
      </template>
      <EmptyNew v-else title="暂无考试">暂无考试</EmptyNew>
    </div>
  </div>
</template>

<script>
import TestCard from "./components/TestCard";
import NoticeTestCard from "./components/NoticeTestCard";
import { mapState, mapMutations } from "vuex";
import EmptyNew from "@/components/EmptyNew.vue";
import { triggerLoaded } from "@/components/LoadContainer.vue";

export default {
  name: "MemberTest",
  components: {
    TestCard,
    EmptyNew,
    NoticeTestCard,
  },
  data() {
    return {
      page: 1,
      limit: 10,
      total: 0,
      testList: [],
      packageInfo: [
        {
          id: "submit_time",
          label: "交卷时间",
          value: "",
        },
        {
          id: "answer_time",
          label: "作答时长",
          value: "",
        },
      ],
      testInfo: [
        {
          id: "time",
          label: "答卷时长",
          value: "",
          unit: "分钟",
        },
        {
          id: "total_ques_num",
          label: "试题总数",
          value: "",
          unit: "道",
        },
        {
          id: "score",
          label: "考试总分",
          value: "",
          unit: "分",
        },
        {
          id: "pass_score",
          label: "通过分数",
          value: "",
          unit: "分",
        },
      ],
      current: "0",
      labelCurrent: "0",
      labelTypes: [
        {
          type: "0",
          label: "我的考试",
        },
        {
          type: "1",
          label: "公共考试",
        },
      ],
    };
  },
  async created() {
    await this.getTestList();
    triggerLoaded(this);
  },
  computed: {
    ...mapState(["testChecked"]),
    types() {
      if (this.labelCurrent == 0) {
        return [
          {
            type: "0",
            label: "全部",
          },
          {
            type: "1",
            label: "待考试",
          },
          {
            type: "2",
            label: "待批阅",
          },
          {
            type: "3",
            label: "已完成",
          },
          {
            type: "4",
            label: "已过期",
          },
        ];
      } else {
        return [
          {
            type: "0",
            label: "全部",
          },
          {
            type: "1",
            label: "已报名",
          },
          {
            type: "2",
            label: "未报名",
          },
        ];
      }
    },
  },
  methods: {
    ...mapMutations(["setTestChecked"]),
    async onCurrentChange(page) {
      this.page = page;
      await this.getTestList();
    },
    //change
    changeLabelTab() {
      this.testList = [];
      this.current = "0";
      this.page = 1;
      if (this.labelCurrent == 0) {
        this.setTestChecked(true);
        this.getTestList();
      } else {
        this.getNoticeTestList();
      }
    },
    changeTab(type) {
      this.current = type;
      this.page = 1;
      if (this.labelCurrent == 0) {
        if (this.current != 0 && this.current != 1) {
          this.setTestChecked(false);
        } else {
          this.setTestChecked(true);
        }
        //调接口查询考试列表
        this.getTestList();
      } else {
        this.getNoticeTestList();
      }
    },
    //查询考试列表
    async getTestList() {
      const res = await this.$http.get("/api/app/test/userTest", {
        status: this.current,
        is_hidden: this.testChecked ? 1 : 0,
        page: this.page,
        limit: this.limit,
      });
      this.testList = res.data || [];
      this.total = res.total;
      this.testList.forEach(i => {
        i.status = this.getTestStatus(i.test_status, i).status;
        i.statusText = this.getTestStatus(i.test_status, i).statusText;
        // 未考试、未提交状态且过期的考试 展示已过期状态
        if (
          i.has_expired &&
          i.test_status != 3 &&
          i.test_status != 2 &&
          i.test_status != 1
        ) {
          i.status = 6;
          i.statusText = "已过期";
        }
        i.answer_time = this.$actionTool.timeMeter(i.answer_time, 3);
        i.submit_time = this.$actionTool.ts(i.submit_time, "yearminute");
        i.time = i.time / 60; //答卷时长，单位是秒
        i.start_time = this.$actionTool.ts(i.start_time);
        i.end_time = this.$actionTool.ts(i.end_time);
        i.testInfo = this.testInfo.map(item => {
          if (item.id == "time" && !i[item.id]) {
            return {
              ...item,
              value: "不限制",
              unit: "",
            };
          }
          return {
            ...item,
            value: i[item.id] || 0,
          };
        });
        i.packageInfo = this.packageInfo.map(item => {
          return {
            ...item,
            value: i[item.id],
          };
        });
        i.courseList = i.course_titles ? i.course_titles.split(",") : [];
      });
    },
    //查询公共考试列表
    async getNoticeTestList() {
      const res = await this.$http.get("/api/app/test/userPublicTest", {
        status: this.current,
        page: this.page,
        limit: this.limit,
      });
      this.testList = res.data || [];
      this.total = res.total;
      this.testList.forEach(i => {
        i.status = this.getTestStatus(i.test_status, i).status;
        i.statusText = this.getTestStatus(i.test_status, i).statusText;
        // 未考试、未提交状态且过期的考试 展示已过期状态
        if (
          i.has_expired &&
          i.test_status != 3 &&
          i.test_status != 2 &&
          i.test_status != 1
        ) {
          i.status = 6;
          i.statusText = "已过期";
        }
        i.answer_time = this.$actionTool.timeMeter(i.answer_time, 3);
        i.submit_time = this.$actionTool.ts(i.submit_time, "yearminute");
        i.time = i.time / 60; //答卷时长，单位是秒
        i.start_time = this.$actionTool.ts(i.start_time);
        i.end_time = this.$actionTool.ts(i.end_time);
        i.testInfo = this.testInfo.map(item => {
          if (item.id == "time" && !i[item.id]) {
            return {
              ...item,
              value: "不限制",
              unit: "",
            };
          }
          return {
            ...item,
            value: i[item.id] || 0,
          };
        });
        i.packageInfo = this.packageInfo.map(item => {
          return {
            ...item,
            value: i[item.id],
          };
        });
        // i.courseList = i.course_titles ? i.course_titles.split(",") : [];
      });
    },
    getTestStatus(type, data) {
      switch (type) {
        case -1:
          return { status: 1, statusText: "待考试" };
        case 0:
          return { status: 2, statusText: "待提交" };
        case 2:
          return { status: 3, statusText: "待批阅" };
        case 1:
          if (data.is_pass == 2) {
            return { status: 5, statusText: "未通过" };
          }
          return { status: 4, statusText: "已通过" };
        case 3: //没有设置人工审批，提交就是已提交
          if (data.is_pass == 2) {
            return { status: 5, statusText: "未通过" };
          }
          return { status: 4, statusText: "已通过" };
      }
    },
    //筛选是否达到考试条件的考试
    changeCheck(value) {
      this.setTestChecked(value);
      this.page = 1;
      //调接口查询考试列表
      this.getTestList();
    },
  },
};
</script>

<style scoped lang="scss">
.member-test {
  background-color: #fff;
  padding: 0 24px 20px 24px;
  //border-radius: 6px;
  .tab-box {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 9px;
    .item {
      margin-right: 16px;
      padding: 6px 16px;
      border: 1px solid #dcdfe6;
      border-radius: 4px;
      font-size: 14px;
      color: #606266;
      cursor: pointer;
      &.active {
        background-color: #bb1c20;
        border: 1px solid #bb1c20;
        color: #fff;
      }
    }
  }
  .filter {
    margin-top: 5px;
    height: 20px;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    margin-bottom: 13px;
    color: #666666;
    .filter-text {
      display: inline-block;
      vertical-align: middle;
    }
    /deep/ .el-checkbox {
      margin-right: 8px;
    }
    /deep/ .el-checkbox__inner {
      //border: 1px solid #bfbfbf;
      border-color: #bfbfbf;
    }
    /deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
      border-color: $primary-color;
    }
  }
  .member-test-content {
    padding-top: 5px;
    .member-test-card {
      margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
